var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error_warp"},[_c('div',{staticClass:"error_tips"},[_c('div',{staticClass:"tips_title"},[_vm._v("!")]),_c('div',{staticClass:"tips_text"},[_vm._v(" 您没有权限访问该资源 ")])])])
}]

export { render, staticRenderFns }